<template>

    <div>
        <Delivery
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.GROCER"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <GrocerTabLinks />
            </template>
        </Delivery>
    </div>

</template>

<script>
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import Delivery from '@/components/delivery/Delivery';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'GrocerDelivery',

        components: {
            Delivery,
            GrocerTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/grocers/${id}`)).data;
        },

        methods: {}
    }
</script>
